/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityEquityBasis {
    UNITS = 'UNITS',
    COST_AT_ISSUE = 'COST_AT_ISSUE',
}
